import {
  addUniqueValueToArray,
  sortArrayWithPositions
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Home/layouts/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DESCRIPTION = NAMESPACE + 'SET_DESCRIPTION'
export const SET_IS_PUBLIC = NAMESPACE + 'SET_IS_PUBLIC'
export const SET_IS_LOCKED = NAMESPACE + 'SET_IS_LOCKED'
export const SET_POSITION = NAMESPACE + 'SET_POSITION'
export const ADD_LAYOUT_GROUP = NAMESPACE + 'ADD_LAYOUT_GROUP'
export const REMOVE_LAYOUT_GROUP = NAMESPACE + 'REMOVE_LAYOUT_GROUP'
export const SET_LAYOUT_GROUPS = NAMESPACE + 'SET_LAYOUT_GROUPS'
export const POSITION_LAYOUT_GROUP = NAMESPACE + 'POSITION_LAYOUT_GROUP'
export const POSITION_LAYOUT_GROUPS = NAMESPACE + 'POSITION_LAYOUT_GROUPS'

const initialState = {
  byId: {},
  isLoading: false,
  isLoaded: false
}

const layoutDefaults = {
  name: '',
  description: null,
  isPublic: false,
  isShared: false,
  isTemplate: false,
  isLocked: false,
  position: 0,
  layoutGroups: [],
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...layoutDefaults,
            ...state.byId[action.payload.id],
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        byId: { ...state.byId }
      }
      action.payload.forEach(item => {
        newState.byId[item.id] = {
          ...layoutDefaults,
          ...newState.byId[item.id],
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            name: action.payload.name
          }
        }
      } : state
    case SET_DESCRIPTION:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            description: action.payload.description
          }
        }
      } : state
    case SET_IS_PUBLIC:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            isPublic: action.payload.isPublic
          }
        }
      } : state
    case SET_IS_LOCKED:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            isLocked: action.payload.isLocked
          }
        }
      } : state
    case SET_POSITION:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            position: action.payload.position
          }
        }
      } : state
    case ADD_LAYOUT_GROUP:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.layoutId]: {
            ...state.byId[action.payload.layoutId],
            layoutGroups: addUniqueValueToArray({
              array: state.byId[action.payload.layoutId].layoutGroups,
              value: action.payload.layoutGroupId,
              index: action.payload.position
            })
          }
        }
      }
    case REMOVE_LAYOUT_GROUP:
      return (
        state.byId[action.payload.layoutId] &&
        state.byId[action.payload.layoutId].layoutGroups.indexOf(action.payload.layoutGroupId) !== -1
      )
        ? {
          ...state,
          byId: {
            ...state.byId,
            [action.payload.layoutId]: {
              ...state.byId[action.payload.layoutId],
              layoutGroups: state.byId[action.payload.layoutId].layoutGroups.filter(boardId => boardId !== action.payload.layoutGroupId)
            }
          }
        }
        : state
    case SET_LAYOUT_GROUPS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.layoutId]: {
            ...state.byId[action.payload.layoutId],
            layoutGroups: action.payload.layoutGroups
          }
        }
      }
    case POSITION_LAYOUT_GROUP: {
      return (
        state.byId[action.payload.layoutId] &&
        state.byId[action.payload.layoutId].layoutGroups.indexOf(action.payload.layoutGroupId) !== -1
      )
        ? {
          ...state,
          byId: {
            ...state.byId,
            [action.payload.layoutId]: {
              ...state.byId[action.payload.layoutId],
              layoutGroups: addUniqueValueToArray({
                array: state.byId[action.payload.layoutId].layoutGroups,
                value: action.payload.layoutGroupId,
                index: action.payload.position
              })
            }
          }
        }
        : state
    }
    case POSITION_LAYOUT_GROUPS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.layoutId]: {
            ...state.byId[action.payload.layoutId],
            layoutGroups: sortArrayWithPositions(state.byId[action.payload.layoutId].layoutGroups, action.payload.positionsById)
          }
        }
      }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setDescription ({ id, description }) {
  return {
    type: SET_DESCRIPTION,
    payload: {
      id,
      description
    }
  }
}

export function setIsPublic ({ id, isPublic }) {
  return {
    type: SET_IS_PUBLIC,
    payload: {
      id,
      isPublic
    }
  }
}

export function setIsLocked ({ id, isLocked }) {
  return {
    type: SET_IS_LOCKED,
    payload: {
      id,
      isLocked
    }
  }
}

export function setPosition ({ id, position }) {
  return {
    type: SET_POSITION,
    payload: {
      id,
      position
    }
  }
}

export function addLayoutGroup ({ layoutId, layoutGroupId, position }) {
  return {
    type: ADD_LAYOUT_GROUP,
    payload: {
      layoutId,
      layoutGroupId,
      position
    }
  }
}

export function removeLayoutGroup ({ layoutId, layoutGroupId }) {
  return {
    type: REMOVE_LAYOUT_GROUP,
    payload: {
      layoutId,
      layoutGroupId
    }
  }
}

export function setLayoutGroups ({ layoutId, layoutGroups }) {
  return {
    type: SET_LAYOUT_GROUPS,
    payload: {
      layoutId,
      layoutGroups
    }
  }
}

export function positionLayoutGroup ({ layoutId, layoutGroupId, position }) {
  return {
    type: POSITION_LAYOUT_GROUP,
    payload: {
      layoutId,
      layoutGroupId,
      position
    }
  }
}

export function positionLayoutGroups ({ layoutId, positionsById }) {
  return {
    type: POSITION_LAYOUT_GROUPS,
    payload: {
      layoutId,
      positionsById
    }
  }
}
